import { HomesMap } from './Map';
import type { MapHomeLocation } from '@habity/types';
import { useMapPolygons } from '~/hooks/useMapPolygons';
import { useHomesStore } from '~/store';

export const SearchMap = ({ homes }: { homes: MapHomeLocation[] | null }) => {
  const search = useHomesStore((state) => state.filters);
  const { polygons } = useMapPolygons({
    areaIds: search?.areaIds,
    municipalityIds: search?.municipalityIds,
  });

  return <HomesMap homes={homes} polygons={polygons} grayscale />;
};
